import script from "./VacancieForm.vue?vue&type=script&setup=true&lang=js"
export * from "./VacancieForm.vue?vue&type=script&setup=true&lang=js"

import "./VacancieForm.vue?vue&type=style&index=0&id=38ee6c45&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38ee6c45"]])

export default __exports__